import {
	AccountBalanceWallet,
	Folder,
	Settings,
	WatchLater,
	AccountBalance,
	LocalOffer,
	Discount,
	Login,
	SpaceDashboard,
	Work,
	People,
	Handshake,
	Badge,
	Assignment,
	PendingActions,
	Dvr,
	AccessTime,
	FormatListNumbered,
	Paragliding,
	EditDocument,
	AssignmentLate,
	AssignmentReturn,
	PriceCheck,
	Person2,
	CalendarMonth,
	Unsubscribe,
	Email,
	Cancel,
	SupervisedUserCircle,
} from "@mui/icons-material";
import { MenuKeys, MenuItem } from "@repo/server-api/types";

export const menuItems: MenuItem[] = [
	{
		label: "Main Features",
		key: MenuKeys.MAIN_FEATURES,
		subItems: [
			{
				label: "Dashboard",
				path: "/",
				icon: SpaceDashboard,
				key: MenuKeys.DASHBOARD,
			},
			{
				label: "Clients",
				path: "/clients",
				icon: Handshake,
				key: MenuKeys.CLIENTS,
			},
			{
				label: "Suppliers",
				path: "/suppliers",
				icon: Badge,
				key: MenuKeys.SUPPLIERS,
			},
			{
				label: "Freelancers",
				path: "/freelancers",
				icon: Paragliding,
				key: MenuKeys.FREELANCERS,
			},
			{
				label: "Contractors",
				path: "/contractors",
				icon: Work,
				key: MenuKeys.CONTRACTORS,
			},
			{
				label: "Employees",
				path: "/employees",
				icon: People,
				key: MenuKeys.EMPLOYEES,
			},
		],
	},
	{
		label: "Projects",
		icon: Folder,
		key: MenuKeys.PROJECTS,
		subItems: [
			{
				label: "List",
				path: "/projects",
				icon: Assignment,
				key: MenuKeys.PROJECTS_LIST,
			},
			{
				label: "Monthly Overview",
				path: "/projects/monthly-overview",
				icon: CalendarMonth,
				key: MenuKeys.PROJECTS_MONTHLY_OVERVIEW,
			},
			{
				label: "Timesheets",
				path: "/projects/timesheets",
				icon: PendingActions,
				key: MenuKeys.PROJECTS_TIMESHEETS,
			},
			{
				label: "My Time Entries",
				path: "/my_projects/time_entries",
				icon: Dvr,
				key: MenuKeys.MY_PROJECTS_TIME_ENTRIES,
			},
			{
				label: "My Timesheets",
				path: "/my_projects/timesheets",
				icon: AccessTime,
				key: MenuKeys.MY_PROJECTS_TIMESHEETS,
			},
		],
	},
	{
		label: "Invoices",
		key: MenuKeys.INVOICES,
		subItems: [
			{
				label: "Draft",
				path: "/invoices/draft",
				icon: EditDocument,
				key: MenuKeys.INVOICES_DRAFT,
			},
			{
				label: "Unsent",
				path: "/invoices/unsent",
				icon: Unsubscribe,
				key: MenuKeys.INVOICES_UNSENT,
			},
			{
				label: "Unpaid",
				path: "/invoices/unpaid",
				icon: AssignmentLate,
				key: MenuKeys.INVOICES_UNPAID,
			},
			{
				label: "Overdue",
				path: "/invoices/overdue",
				icon: AssignmentReturn,
				key: MenuKeys.INVOICES_OVERDUE,
			},
			{
				label: "Paid",
				path: "/invoices/paid",
				icon: PriceCheck,
				key: MenuKeys.INVOICES_PAID,
			},
			{
				label: "Cancelled",
				path: "/invoices/cancelled",
				icon: Cancel,
				key: MenuKeys.INVOICES_CANCELLED,
			},
		],
	},
	{
		label: "Offers",
		key: MenuKeys.OFFERS,
		subItems: [
			{
				label: "Draft",
				path: "/offers/draft",
				icon: EditDocument,
				key: MenuKeys.OFFERS_DRAFT,
			},
			{
				label: "Unsent",
				path: "/offers/unsent",
				icon: Unsubscribe,
				key: MenuKeys.OFFERS_UNSENT,
			},
			{
				label: "Open",
				path: "/offers/open",
				icon: LocalOffer,
				key: MenuKeys.OFFERS_OPEN,
			},
			{
				label: "Accepted",
				path: "/offers/accepted",
				icon: LocalOffer,
				key: MenuKeys.OFFERS_ACCEPTED,
			},
			{
				label: "Rejected",
				path: "/offers/rejected",
				icon: LocalOffer,
				key: MenuKeys.OFFERS_REJECTED,
			},
			{
				label: "Overdue",
				path: "/offers/overdue",
				icon: AssignmentReturn,
				key: MenuKeys.OFFERS_OVERDUE,
			},
		],
	},
	{
		label: "Settings",
		icon: Settings,
		key: MenuKeys.SETTINGS,
		subItems: [
			{
				label: "Account",
				path: "/settings/account",
				icon: Person2,
				key: MenuKeys.SETTINGS_ACCOUNT,
			},
			{
				label: "Logins",
				path: "/admin/logins",
				icon: Login,
				key: MenuKeys.ADMIN_LOGINS,
			},
			{
				label: "Supplier Members",
				path: "/supplier/impersonation",
				icon: SupervisedUserCircle,
				key: MenuKeys.SUPPLIER_IMPERSONATION,
			},
			{
				label: "Services",
				path: "/settings/services",
				icon: Settings,
				key: MenuKeys.SETTINGS_SERVICES,
			},
			{
				label: "Accounting Profiles",
				path: "/settings/accounting_profiles",
				icon: AccountBalance,
				key: MenuKeys.SETTINGS_ACCOUNTING_PROFILES,
			},
			{
				label: "Discount Profiles",
				path: "/settings/discount_profiles",
				icon: Discount,
				key: MenuKeys.SETTINGS_DISCOUNT_PROFILES,
			},
			{
				label: "Rolling Numbers",
				path: "/settings/rolling_numbers",
				icon: FormatListNumbered,
				key: MenuKeys.SETTINGS_ROLLING_NUMBERS,
			},
			{
				label: "Mail Configuration",
				path: "/settings/mail_configuration",
				icon: Email,
				key: MenuKeys.SETTINGS_MAIL_CONFIGURATION,
			},
		],
	},
	{
		label: "Finances",
		icon: AccountBalanceWallet,
		key: MenuKeys.FINANCES,
		subItems: [
			{
				label: "Dashboard",
				path: "/finances/dashboard",
				key: MenuKeys.FINANCES_DASHBOARD,
			},
			{
				label: "Invoices",
				path: "/finances/invoices",
				key: MenuKeys.FINANCES_INVOICES,
			},
		],
	},
	// {
	// 	label: "Accounting",
	// 	icon: AccountBalance,
	// 	key: MenuKeys.ACCOUNTING,
	// 	subItems: [
	// 		{
	// 			label: "Absence Overview",
	// 			path: "/accounting/absence_overview",
	// 			key: MenuKeys.ACCOUNTING_ABSENCE_OVERVIEW,
	// 		},
	// 	],
	// },
	{
		label: "My Time Management",
		icon: WatchLater,
		key: MenuKeys.MY_TIME_MANAGEMENT,
		subItems: [
			{
				label: "My time entries",
				path: "/time_management/internal/user",
				key: MenuKeys.MY_TIME_ENTRIES,
			},
			{
				label: "Absence",
				path: "/time_management/absence",
				key: MenuKeys.ABSENCE,
			},
			{
				label: "Vacation Requests",
				path: "/time_management/vacation_requests",
				key: MenuKeys.VACATION_REQUESTS,
			},
		],
	},
	{
		label: "Team Time Management",
		icon: WatchLater,
		key: MenuKeys.TEAM_TIME_MANAGEMENT,
		subItems: [
			{
				label: "Time entries",
				path: "/time_management/internal/admin",
				key: MenuKeys.TIME_ENTRIES,
			},
			{
				label: "Team Absences",
				path: "/time_management/team_absences",
				key: MenuKeys.TEAM_ABSENCE,
			},
		],
	},
	{
		label: "HR Time Management",
		icon: WatchLater,
		key: MenuKeys.TIME_MANAGEMENT,
		subItems: [
			{
				label: "Time Balances",
				path: "/time_management/time_balances",
				key: MenuKeys.TIME_BALANCES,
			},
			{
				label: "Absences",
				path: "/time_management/hr_absence",
				key: MenuKeys.HR_ABSENCE,
			},
			{
				label: "HR Time Entries",
				path: "/time_management/hr_time_entries",
				key: MenuKeys.HR_TIME_ENTRIES,
			},
		],
	},
	{
		label: "Time Management Settings",
		icon: WatchLater,
		key: MenuKeys.TIME_MANAGEMENT_SETTINGS,
		subItems: [
			{
				label: "Time Labels",
				path: "/time_management/time_labels",
				key: MenuKeys.TIME_LABELS,
			},
			{
				label: "Absence Reasons",
				path: "/time_management/absence_reasons",
				key: MenuKeys.ABSENCE_REASONS,
			},
			{
				label: "Calendar Events",
				path: "/time_management/calendar_events",
				key: MenuKeys.CALENDAR_EVENTS,
			},
			{
				label: "Working Time Models",
				path: "/time_management/working_time_models",
				key: MenuKeys.WORKING_TIME_MODELS,
			},
			//TODO
			{
				label: "Timesheet",
				path: "/time_management/timesheet",
				key: MenuKeys.TIMESHEET,
			},
		],
	},
];
